import 'motivate-framework/dist/css/motivate.css';
import Vue from 'vue';
import {initIl8n} from './plugins/i18n';
import 'sweetalert2/dist/sweetalert2.min.css';

import App from './App.vue';
import router from './router/index';
import store from './store';
import './init/components/importGlobalFrameworkComponents';
import './init/components/importGlobalComponents';
import './init/importGlobalFilters';
import './init/importGlobalEventBus';
import './registerServiceWorker';
import onScan from './init/HIDScanner';
import isMobile from './plugins/isMobile';
import MotivateAuth from './init/auth';
import BarcodeScanner from 'vue-zebra-barcode-scanner';

Vue.prototype.$BluetoothScan = onScan;
window._ = require('lodash');
window.moment = require('moment');
Vue.prototype.$auth = new MotivateAuth();

Vue.config.performance = false;

if (isMobile.check()) {
    document.addEventListener('deviceready', initializeAppBeforeRender, false);
} else {
    initializeAppBeforeRender().catch(e => {
        alert(e);
    }); //this is the browser
}


async function initializeAppBeforeRender() {
    initalizeAppRender();
}

async function initalizeAppRender(login = false) {
    if (!login) {
        renderVue(initIl8n({
            "fallbackLocale": "nl",
            "locale": "nl"
        }));
    }

}
function renderVue(i18n) {
    new Vue({
        router: router,
        store: store,
        i18n,
        render: h => h(App)
    }).$mount('#app');
}
